import { Link } from 'react-router-dom';

const tasks = [
  {
    symptom: 'Сделки не дожимаются до конца',
    solution: 'Тренинг по продажам',
    to: '/prodazhi-i-peregovory/trening-po-prodazham',
  },
  {
    symptom: 'Клиенты давят ценой и просят скидку',
    solution: 'Работа с возражениями',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami',
  },
  {
    symptom: 'Много звонков, но мало встреч',
    solution: 'Холодные звонки',
    to: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam',
  },
  {
    symptom: 'Клиент пропадает после первого контакта',
    solution: 'Продажи через переписку',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-cherez-perepisku',
  },
  {
    symptom: 'Длинный цикл B2B и несколько ЛПР',
    solution: 'Продажи B2B',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-b2b',
  },
  {
    symptom: 'Сложные переговоры с закупщиками',
    solution: 'Тренинг по переговорам',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
  },
  {
    symptom: 'Менеджеры не слышат потребности клиента',
    solution: 'Выявление потребностей',
    to: '/prodazhi-i-peregovory/trening-po-vyyavleniyu-potrebnostey',
  },
  {
    symptom: 'Клиенты не возвращаются',
    solution: 'Работа с клиентами',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-klientami',
  },
];

export default function TaskNavigator() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-compass-3-line"></i>
            Навигатор по задачам
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
            Найдите программу по своей задаче
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Не нужно выбирать вслепую. Узнали свою ситуацию — переходите сразу к нужной программе.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-5xl mx-auto">
          {tasks.map((t, i) => (
            <Link
              key={i}
              to={t.to}
              className="group bg-white rounded-xl p-5 border border-gray-100 hover:border-teal-200 hover:bg-teal-50/40 transition-all flex items-center gap-4 cursor-pointer"
            >
              <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                <i className="ri-question-line text-teal-600 group-hover:text-white transition-colors"></i>
              </div>
              <div className="flex-1">
                <div className="text-gray-900 font-semibold text-sm md:text-base leading-snug">
                  «{t.symptom}»
                </div>
                <div className="text-teal-700 text-xs md:text-sm mt-1 inline-flex items-center gap-1.5">
                  <i className="ri-arrow-right-line"></i>
                  {t.solution}
                </div>
              </div>
              <i className="ri-arrow-right-up-line text-gray-300 group-hover:text-teal-600 transition-colors"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}